/*******************************************************************************
SHOW ERROR NOTIFICATION
Show an error notification at the bottom of the screen.
*******************************************************************************/

import removeErrorNotificationBar from './remove-error-notification-bar';

export default function showErrorNotification(message, duration = 'forever') {

    // Remove any existing error bars (just in case they trigger multiple errors quickly)
    removeErrorNotificationBar();

    // Build the error message html
    const errorHTML = `<div class="error-notification-bar">${message}</div>`;

    // Show an error message at the bottom of the screen
    $('body').append(errorHTML);

    // Remove the error bar from the page after a set amount of time
    // Unless the duration is set to 'forever'
    if (duration !== 'forever') { setTimeout(() => { removeErrorNotificationBar(); }, duration); }
}
